
import React from 'react';
import ReactDOM from 'react-dom/client';
import AppRouter from './AppRouter';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import './global.css';
import './fonts.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppRouter />
    </ThemeProvider>
  </React.StrictMode>
);

// Service Worker policy:
// - Development: unregister all SWs and clear caches to avoid stale assets/white screen.
// - Production mobile/tablet: register PWA worker.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    const isDev = process.env.NODE_ENV === 'development';

    if (isDev) {
      try {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
        if ('caches' in window) {
          const keys = await window.caches.keys();
          await Promise.all(keys.map((k) => window.caches.delete(k)));
        }
        console.log('Service Workers e caches limpos no desenvolvimento.');
      } catch (error) {
        console.log('Falha ao limpar Service Worker no desenvolvimento:', error);
      }
      return;
    }

    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isTablet = /iPad|Android/i.test(navigator.userAgent) && window.innerWidth <= 1024;

    if (isMobile || isTablet) {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
          console.log('Service Worker registrado com sucesso:', registration.scope);
        })
        .catch((error) => {
          console.log('Falha ao registrar Service Worker:', error);
        });
    }
  });
}

// Inicializa cliente WebSocket apenas se o usuário estiver autenticado e token não expirado
function _tokenValido(token) {
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    if (payload.exp && payload.exp * 1000 < Date.now()) return false;
    return true;
  } catch { return false; }
}

try {
  const token = localStorage.getItem('token');
  if (_tokenValido(token)) {
    const wsUrl = process.env.REACT_APP_WS_URL || 'wss://api.conectachurch.com.br/ws';
    import('./wsClient').then(({ createWebSocket }) => {
      const ws = createWebSocket(wsUrl, { token, maxAttempts: 3 });
      if (ws) {
        ws.connect();
        window.__APP_WS__ = ws;
      }
    }).catch(() => {});
  } else {
    // token ausente ou expirado — não conectar WS
    localStorage.removeItem('token');
  }
} catch (err) {
  // silencioso — WebSocket é opcional
}
